import { RFITracker } from '../../../cimsPage/instances/rfi'
import { BasicPermissionItem } from '../../PermissionItem'
import {
  CreateViewEditSoftRemoveRestore,
  Revert,
  Simple,
  Unlock,
} from '../../common'

const page = RFITracker
const object = 'Request For Information'
const plural = 'requests for information'

const rfi = CreateViewEditSoftRemoveRestore({
  page,
  object,
  plural,
  create: '2AACC6FA-1A07-4BC1-9A3C-1DB93B1BA196',
  view: '6CE931FF-B82C-4F79-864E-167D9F383EFC',
  edit: '2E62C4F9-F030-4830-8FD3-2B29FF7C9B13',
  removeRestore: 'AE5AE1C3-D9C8-41C3-9AE1-FC5989AF1BEE',
})

export const CreateRequestForInformation = rfi.Create
export const ViewRequestForInformation = rfi.View
export const EditRequestForInformation = rfi.Edit
export const RemoveRestoreRequestForInformation = rfi.RemoveRestore

export const CommentOnRequestForInformation = Simple({
  id: 'DF0BEF36-E5F3-439E-ACF7-756437482C24',
  action: 'Comment on',
  page,
  object,
  plural,
})

export const RespondAllRFIResponseDisciplines = new BasicPermissionItem({
  id: '4457FCE3-E48B-4ACE-807F-228A27F56611',
  name: `Respond All Response Disciplines`,
  action: 'respond to all response disciplines',
  page,
  allowMixedCase: true,
})

export const RevertRequestForInformation = Revert({
  id: '237A9CCC-E3BB-46A6-ADC4-E8B96F3A57C5',
  page,
  object,
  plural,
})

export const UnlockRequestForInformation = Unlock({
  id: 'A7718BEC-A285-4A45-8FED-72D55545C539',
  page,
  object,
  plural,
})

export type RFITrackerPermission =
  | typeof CreateRequestForInformation
  | typeof ViewRequestForInformation
  | typeof EditRequestForInformation
  | typeof RemoveRestoreRequestForInformation
  | typeof CommentOnRequestForInformation
  | typeof RespondAllRFIResponseDisciplines
  | typeof RevertRequestForInformation
  | typeof UnlockRequestForInformation
